import { 
    Image,
    useMantineTheme,
} from '@mantine/core';
import Logo_LightMode from '../assets/logo/ticketin.svg';
import Logo_DarkMode from '../assets/logo/ticketin-darkmode.svg';

export default function Logo (props) {

    const theme = useMantineTheme();

    return (
        <Image
            src={theme.colorScheme === 'light' ? Logo_LightMode : Logo_DarkMode} 
            {...props}
        />
    )

}